"use client";

import { Component, type ReactNode } from "react";

interface BlockErrorBoundaryProps {
  children: ReactNode;
  blockType?: string;
  blockId?: string;
}

interface BlockErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class BlockErrorBoundary extends Component<
  BlockErrorBoundaryProps,
  BlockErrorBoundaryState
> {
  state: BlockErrorBoundaryState = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): BlockErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack?: string }) {
    // eslint-disable-next-line no-console
    console.error(
      `[BlockErrorBoundary] ${this.props.blockType ?? "unknown"} (${this.props.blockId ?? "no-id"}) crashed:`,
      error,
      errorInfo.componentStack
    );
  }

  render() {
    if (this.state.hasError) {
      if (process.env.NODE_ENV === "development") {
        return (
          <div className="border border-red-500 bg-red-50 p-4 text-sm text-red-900">
            <strong>Block crashed:</strong> {this.props.blockType ?? "unknown"}{" "}
            ({this.props.blockId ?? "no-id"})
            <pre className="mt-2 whitespace-pre-wrap text-xs">
              {this.state.error?.message}
            </pre>
          </div>
        );
      }
      return null;
    }

    return this.props.children;
  }
}
